import React from "react";
import Dashboard from "../../pages/dashboard/Dashboard";
import ProductImport from "../../pages/productImport/ProductImport";
import ProductImportDetail from "../../pages/productImport/feature/ProductImportDetail";

const DatabaseHealth = React.lazy(() => import("../../pages/databaseHealth/DatabaseHealth"));
const NotFound = React.lazy(() => import("../../pages/errors/NotFound"));
const Regulations = React.lazy(() => import('../../pages/regulations/Regulations'));
const AddEditRegulations = React.lazy(() => import('../../pages/regulations/AddEditRegulation'));
const Products = React.lazy(() => import('../../pages/products/Products'));
const ProductDetail = React.lazy(() => import('../../pages/products/ProductDetail'));
const RegulationProducts = React.lazy(() => import('../../pages/regulations/RegulationProducts'));
const ErrorProducts = React.lazy(() => import('../../pages/errorProducts/ErrorProducts'));
const RegulationRequest = React.lazy(() => import('../../pages/regulationRequest/component/RegulationRequest'));
const RegulationRequestList = React.lazy(() => import('../../pages/regulationRequest/component/RegulationRequestList'));
const RegulationRequestDetail = React.lazy(() => import('../../pages/regulationRequest/component/RegulationRequestDetail'));
const ImageRequest = React.lazy(() => import('../../pages/imageGenerationRequest/component/ImageRequest'));
const ImageRequestList = React.lazy(() => import('../../pages/imageGenerationRequest/component/ImageRequestList'));
const ImageRequestDetail = React.lazy(() => import('../../pages/imageGenerationRequest/component/ImageRequestDetail'));
const LinkupRequest = React.lazy(() => import('../../pages/LinkupRequest/LinkupRequest'));
const LinkupRequestDetail = React.lazy(() => import('../../pages/LinkupRequest/features/LinkupRequestDetails'));
const SyncData = React.lazy(() => import('../../pages/syncData/components/SyncData'));
const Configuration = React.lazy(() => import('../../pages/configuration/Configuration'));
const PropertyData = React.lazy(() => import('../../pages/configuration/PropertyData'));
const PrecautionaryData = React.lazy(() => import('../../pages/configuration/PrecautionaryData'));
const PictogramAsset = React.lazy(() => import('../../pages/configuration/PictogramAsset'));
const HazardStatementData = React.lazy(() => import('../../pages/configuration/HazardStatementData'));
const SafetyData = React.lazy(() => import('../../pages/configuration/SafetyData'));
const SynonymData = React.lazy(() => import('../../pages/configuration/SynonymData'));
const SchedulerConfiguration = React.lazy(() => import('../../pages/configuration/SchedulerConfiguration'));
const AppManagment = React.lazy(() => import('../../pages/configuration/AppManagment'));
const ApplicationDetail = React.lazy(() => import('../../pages/configuration/ApplicationDetail'));
const Applications = React.lazy(() => import('../../pages/configuration/Applications'));
const ApplicationProductsDetail = React.lazy(() => import('../../pages/configuration/ApplicationProductsDetail'));
// const ChemPatternData = React.lazy(() => import('../../pages/configuration/ChemPatternData'));
const SyncDataDetail = React.lazy(() => import('../../pages/syncData/components/SyncDataDetail'));
const Unauthorize = React.lazy(() => import('../../pages/unauthorize/Unauthorize'));


export const ComponentNavigation = [
  {
    id: "pageNotFound",
    path: "pageNotFound",
    exact: true,
    title: "",
    component: NotFound,
    text: "Page not found",
    securityKey: "",
    allowrole: ['Admin'],
  },

  /** Regulations */
  {
    id: 'regulations',
    path: '/Regulations',
    exact: true,
    title: 'Regulations',
    component: Regulations,
    hasParams: false,
    text: 'Regulations',
    securityKey: "",
    allowrole: ['Admin'],
  },
  {
    id: 'addRegulations',
    path: '/AddRegulations',
    exact: true,
    title: 'Add Regulations',
    component: AddEditRegulations,
    hasParams: false,
    text: 'Add Regulations',
    securityKey: "",
    allowrole: ['Admin'],
  },
  {
    id: 'editRegulations',
    path: '/EditRegulations/:id',
    exact: true,
    title: 'Edit Regulations',
    component: AddEditRegulations,
    hasParams: true,
    text: 'Edit Regulations',
    securityKey: "",
    allowrole: ['Admin'],
  },
  {
    id: 'databaseHealth',
    path: '/DatabaseHealth',
    exact: true,
    title: 'DatabaseHealth',
    component: DatabaseHealth,
    hasParams: false,
    text: 'DatabaseHealth',
    securityKey: "",
    allowrole: ['Admin'],
  },
  {
    id: 'products',
    path: '/Products',
    exact: true,
    title: 'Products',
    component: Products,
    hasParams: false,
    text: 'Products',
    securityKey: "",
    allowrole: ['Admin'],
  },
  {
    id: 'productDetail',
    path: '/ProductDetail/:id',
    exact: true,
    title: 'Product Detail',
    component: ProductDetail,
    hasParams: true,
    text: 'Product Detail',
    securityKey: "",
    allowrole: ['Admin'],
  },

  {
    id: 'regulationproducts',
    path: '/RegulationProducts',
    exact: true,
    title: 'Regulation Products',
    component: RegulationProducts,
    hasParams: false,
    text: 'Regulation Products',
    securityKey: "",
    allowrole: ['Admin'],
  },
  {
    id: 'errorproducts',
    path: '/ErrorProducts',
    exact: true,
    title: 'ErrorProducts',
    component: ErrorProducts,
    hasParams: false,
    text: 'ErrorProducts',
    securityKey: "",
    allowrole: ['Admin'],
  },
  {
    id: 'regulationRequest',
    path: '/RegulationRequest',
    exact: true,
    title: 'Regulation Request',
    component: RegulationRequest,
    hasParams: false,
    text: 'Regulation Request',
    securityKey: "",
    allowrole: ['Admin'],
  },
  {
    id: 'regulationRequestList',
    path: '/RegulationRequestList',
    exact: true,
    title: 'Regulation Request',
    component: RegulationRequestList,
    hasParams: false,
    text: 'Regulation Request',
    securityKey: "",
    allowrole: ['Admin'],
  },

  {
    id: 'regulationRequestDetail',
    path: '/regulationRequestDetail/:id',
    exact: true,
    title: 'Add Regulation Request',
    component: RegulationRequestDetail,
    hasParams: true,
    text: 'Add Regulation Request',
    securityKey: "",
    allowrole: ['Admin'],
  },

  {
    id: 'linkuprequest',
    path: '/LinkupRequest',
    exact: true,
    title: 'LinkupRequest',
    component: LinkupRequest,
    hasParams: false,
    text: 'LinkupRequest',
    securityKey: "",
    allowrole: ['Admin'],
  },
  {
    id: 'linkupRequestDetail',
    path: '/LinkupRequestDetail/:id',
    exact: true,
    title: 'Linkup Request Detail',
    component: LinkupRequestDetail,
    hasParams: false,
    text: 'Linkup Request Detail',
    securityKey: "",
    allowrole: ['Admin'],
  },
  {
    id: 'productImport',
    path: '/ProductImport',
    exact: true,
    title: 'ProductImport',
    component: ProductImport,
    hasParams: false,
    text: 'ProductImport',
    securityKey: "",
    allowrole: ['Admin'],
  },

  {
    id: 'dashboard',
    path: '/Dashboard',
    exact: true,
    title: 'Dashboard',
    component: Dashboard,
    hasParams: false,
    text: 'Dashboard',
    securityKey: "",
    allowrole: ['Admin'],
  },
  {
    id: 'unauthorize',
    path: '/unauthorize',
    exact: true,
    title: 'Unauthorize',
    component: Unauthorize,
    hasParams: false,
    text: 'unauthorize',
    securityKey: "",
    allowrole: ['Admin'],
  },
  {
    id: 'syncData',
    path: '/SyncData',
    exact: true,
    title: 'Sync Data',
    component: SyncData,
    hasParams: false,
    text: 'Sync Data',
    securityKey: "",
    allowrole: ['Admin'],
  },

  {
    id: 'configuration',
    path: '/Configuration',
    exact: true,
    title: 'Configuration',
    component: Configuration,
    hasParams: false,
    text: 'Configuration',
    securityKey: "",
    allowrole: ['Admin'],
  },
  {
    id: 'PropertyData',
    path: '/Configuration/PropertyData',
    exact: true,
    title: 'Property Data',
    component: PropertyData,
    allowrole: ['Admin']
  },
  // {
  //   id: 'ChemPatternData',
  //   path: '/Configuration/ChemPatternData',
  //   exact: true,
  //   title: 'ChemPattern Data',
  //   component: ChemPatternData,
  //   allowrole: ['Admin']
  // },
  {
    id: 'Precautionary Data',
    path: '/Configuration/PrecautionaryData',
    exact: true,
    title: 'Precautionary Data',
    component: PrecautionaryData,
    allowrole: ['Admin']
  },
  {
    id: 'Pictogram Asset',
    path: '/Configuration/PictogramAsset',
    exact: true,
    title: 'Pictogram Asset',
    component: PictogramAsset,
    allowrole: ['Admin']
  },
  {
    id: 'Hazard Statement',
    path: '/Configuration/HazardStatement',
    exact: true,
    title: 'Hazard Statement',
    component: HazardStatementData,
    allowrole: ['Admin']
  },
  {
    id: 'SafetyData',
    path: '/Configuration/SafetyData',
    exact: true,
    title: 'Safety Data',
    component: SafetyData,
    allowrole: ['Admin']
  },
  {
    id: 'SynonymData',
    path: '/Configuration/SynonymData',
    exact: true,
    title: 'Synonym Data',
    component: SynonymData,
    allowrole: ['Admin']
  },
  {
    id: 'linkuprequest',
    path: '/LinkupRequest',
    exact: true,
    title: 'LinkupRequest',
    component: LinkupRequest,
    hasParams: false,
    text: 'LinkupRequest',
    securityKey: "",
    allowrole: ['Admin'],
  },
  {

    id: 'syncDataDetail',
    path: '/syncDataDetail/:id',
    exact: true,
    title: 'View Sync Data Detail',
    component: SyncDataDetail,
    hasParams: true,
    text: 'View Sync Data Detail',
    securityKey: "",
    allowrole: ['Admin'],
  },
  {
    id: 'productImportDetail',
    path: '/ProductImportDetail/:id',
    exact: true,
    title: 'Product Import Detail',
    component: ProductImportDetail,
    hasParams: false,
    text: 'Product Import Detail',
    securityKey: "",
    allowrole: ['Admin'],
  },

  {
    id: 'imageGenerationRequest',
    path: '/ImageGenerationRequest',
    exact: true,
    title: 'Image Generation Request',
    component: ImageRequest,
    hasParams: false,
    text: 'Image Generation Request',
    securityKey: "",
    allowrole: ['Admin'],
  },
  {
    id: 'imageGenerationRequestList',
    path: '/ImageRequestList',
    exact: true,
    title: 'Image Generation Request List',
    component: ImageRequestList,
    hasParams: false,
    text: 'Image Generation Request',
    securityKey: "",
    allowrole: ['Admin'],
  },

  {
    id: 'imageRequestDetail',
    path: '/ImageRequestDetail/:id',
    exact: true,
    title: 'Image Request List',
    component: ImageRequestDetail,
    hasParams: true,
    text: 'Image Request List',
    securityKey: "",
    allowrole: ['Admin'],
  },
  {
    id: 'Scheduler',
    path: '/Configuration/SchedulerDetails',
    exact: true,
    title: 'Scheduler Request List',
    component: SchedulerConfiguration,
    hasParams: true,
    text: 'Scheduler Request List',
    securityKey: "",
    allowrole: ['Admin'],
  },
  {

    id: 'AppManagment',
    path: '/Configuration/AppManagement',
    exact: true,
    title: 'App Management',
    component: AppManagment,
    hasParams: false,
    text: 'App Management',
    securityKey: "",
    allowrole: ['Admin'],
  },
  {
    id: 'ApplicationDetail',
    path: '/Configuration/ApplicationDetail/:id',
    exact: true,
    title: 'Application Detail',
    component: ApplicationDetail,
    hasParams: false,
    text: 'Application Detail',
    securityKey: "",
    allowrole: ['Admin'],
  },
  {
    id: 'Applications',
    path: '/Configuration/Applications',
    exact: true,
    title: 'Applications',
    component: Applications,
    hasParams: false,
    text: 'Applications',
    securityKey: "",
    allowrole: ['Admin'],
  },
  {
    id: 'ApplicationProductsDetail',
    path: '/Configuration/Applications/:id',
    exact: true,
    title: 'Application Products Detail',
    component: ApplicationProductsDetail,
    hasParams: true,
    text: 'Application Products Detail',
    securityKey: "",
    allowrole: ['Admin'],
  },
];